import { ApiBase } from '../api-base'

export class AccountServices extends ApiBase {
  constructor() {
    super({
      resource: '/api/v1/accounts',
      name: 'account',
      successPath: '/accounts'
    })
  }

  getManagments() {
    return this.api.get(`${this.resource}/managments`)
  }

  getCountries() {
    return this.api.get(`${this.resource}/countries`)
  }
}
